import { TrackingApi } from '../../../../api/Tracking'
import AddTracking from '../../../../components/Main/Tracking/AddTracking/AddTracking'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData, { MODAL_TYPE_EDIT, MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import moment from 'moment'
import React from 'react'
import { get, isEmpty, omit, pick, round } from 'lodash'
import useTitle from '../../../../elements/Hooks/useTitle'
import { withRouter } from 'react-router-dom'

AddTrackingCont.propTypes = {}

function getRandHex(len = 5) {
  return round(Math.random() * Math.pow(10, len) * 16)
    .toString(16)
    .toUpperCase()
}

function AddTrackingCont(props) {
  const key = get(props.match, 'params.key')

  const { list: subTrackingList, fetching: fetchingSubTracking, fetch: fetchSubTracking } = useFetchList(
    () => TrackingApi.list('*', `master=${key}&type=sub`),
    [key],
    isEmpty(key)
  )

  const {
    visible,
    modalType,
    object: tracking,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    fetching,
    fetchObject: fetch,
  } = useModalData(
    TrackingApi.create,
    TrackingApi.update,
    TrackingApi.remove,
    undefined,
    key,
    TrackingApi.read,
    (key) => props.history.replace({ pathname: `/tracking/${key}/update` }),
    () => props.history.replace({ pathname: `/tracking/` })
  )

  const [submittingSub, submitSubFunc] = useSubmit(TrackingApi.create)

  async function submitSub() {
    const data = await submitSubFunc({
      ...omit(tracking, ['_key', '_id', '_rev', '_history']),
      trackingNumber: `${tracking.trackingNumber}-${getRandHex(2)}`,
      type: 'sub',
      date: moment(),
      status: 'Start',
      master: pick(tracking, ['_key', '_id', '_rev']),
    })

    props.history.replace({ pathname: `/tracking/${data._key}/update` })
  }

  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW
  const isNew = type === MODAL_TYPE_NEW
  useTitle(
    tracking.trackingNumber === undefined ? `Create New Tracking Number` : `Tracking Number: ${tracking.trackingNumber}`
  )

  return (
    <AddTracking
      {...{
        type,
        visible,
        modalType,
        tracking,
        submitting,
        submit,
        submittingSub,
        getRandHex,
        submitSub,
        removing,
        remove,
        formRef,
        onShow,
        onCancel,
        update,
        isNew,
        subTrackingList,
        fetchingSubTracking,
        fetchSubTracking,
        fetching,
        fetch,
      }}
    />
  )
}

export default withRouter(AddTrackingCont)
